import type { FolderDetailCategory } from 'shared/src/api/likedFolderService/getFolderDetailCategories';

export type SortType = {
  key: string;
  name: string;
};

export const SORT_TYPES: SortType[] = [
  { key: 'LIKE_LATEST', name: '담은순' },
  { key: 'POPULAR', name: '인기순' },
  { key: 'LATEST', name: '최신순' },
  { key: 'LOW_PRICE', name: '낮은 가격순' },
  { key: 'MORE_REVIEWS', name: '리뷰 많은순' },
];

export const DELIVERY_REQUEST_LIST = {
  standard: [],
  shak: [1],
  today: [3],
  fast: [1, 3],
} as const;

export type DeliveryToggleType = keyof typeof DELIVERY_REQUEST_LIST;

export const ALL_CATEGORY: FolderDetailCategory = { sno: -1, name: '전체' };

export const FOLDER_TYPE = {
  DEFAULT: '기본서랍',
  CUSTOM: '제작서랍',
} as const;

export type FolderType = (typeof FOLDER_TYPE)[keyof typeof FOLDER_TYPE];
